import { GameContext } from '../../contexts/GameContext';
import { M_GAME_NAME, ZDAR_ESCAPE_GAME_NAME, ZDAR_KIDS_GAME_NAME } from '../../configuration/gamesConfiguration';
import { ZdarKidsGameContextProvider } from '../../contexts/ZdarKidsGameContext';
import { useContext, useEffect } from 'react';
import MGame from '../games/m-game/MGame';
import PageWrapper from '../../components/common/wrappers/PageWrapper';
import ZdarGame from '../games/zdar-escape-game/ZdarGame';
import ZdarKidsGame from '../games/zdar-kids-game/ZdarKidsGame';

type Props = {
    name: string;
    lastStep: number;
};

export default function Game({ name, lastStep }: Props) {
    const { setGameConfiguration } = useContext(GameContext);

    useEffect(() => {
        setGameConfiguration(name, lastStep);
    }, [name, setGameConfiguration, lastStep]);

    return (
        <PageWrapper>
            <div className="game-screen">
                {name === ZDAR_ESCAPE_GAME_NAME && <ZdarGame />}
                {name === M_GAME_NAME && <MGame />}
                {name === ZDAR_KIDS_GAME_NAME && (
                    <ZdarKidsGameContextProvider>
                        <ZdarKidsGame />
                    </ZdarKidsGameContextProvider>
                )}
            </div>
        </PageWrapper>
    );
}
